"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var ModulesFlyout = /** @class */ (function (_super) {
                __extends(ModulesFlyout, _super);
                function ModulesFlyout(props) {
                    var _this = _super.call(this, props) || this;
                    _this.modulesChanged = function () {
                        if (_this.state.activeModule !== DynReact.ModuleStore.getActiveModuleLabel()) {
                            _this.props.SetSelectedFlyoutItem(0);
                        }
                        _this.setState({
                            activeLinks: DynReact.ModuleStore.getActiveLinks(),
                            activeModule: DynReact.ModuleStore.getActiveModuleLabel(),
                            loading: DynReact.ModuleStore.getLoadingState(),
                        });
                    };
                    _this.menuExpandView = function () {
                        DynReact.ModuleStore.menuExpandCollapseAll(_this.state.activeLinks, true);
                    };
                    _this.menuCollapseView = function () {
                        DynReact.ModuleStore.menuExpandCollapseAll(_this.state.activeLinks, false);
                    };
                    _this.state = {
                        activeLinks: DynReact.ModuleStore.getActiveLinks(),
                        activeModule: DynReact.ModuleStore.getActiveModuleLabel(),
                        loading: DynReact.ModuleStore.getLoadingState(),
                    };
                    return _this;
                }
                ModulesFlyout.prototype.componentWillMount = function () {
                    // check if we have a active module - this can happen when opening modules after recent or fav
                    if (!this.state.activeModule && DynReact.ModuleStore.getActiveModuleLabel()) {
                        // have a active module , so update the state
                        this.modulesChanged();
                    }
                };
                ModulesFlyout.prototype.componentDidMount = function () {
                    DynReact.ModuleStore.addSubscription(this.modulesChanged);
                    if (this.state.activeModule) {
                        this.recalculateFlyoutWidth();
                    }
                };
                ModulesFlyout.prototype.componentWillUnmount = function () {
                    DynReact.ModuleStore.removeSubscription(this.modulesChanged);
                };
                ModulesFlyout.prototype.componentDidUpdate = function (prevProps, prevState) {
                    // Don't waste cycles recalculating the flyout width if the links didn't change as part of this update.
                    if (this._lastLinkCount !== this._currentLinkCount || prevState.activeModule !== this.state.activeModule) {
                        this.recalculateFlyoutWidth();
                    }
                    // check to show whatsNew dialog
                    if (DynReact.ModuleStore.getActiveModuleLabel() && // must have name
                        prevState.activeModule !== this.state.activeModule && // only show on new module
                        !DynReact.ModuleStore.hasAnyPersonalizations && // dont show if personalizations exist
                        !DynReact.ModuleStore.hideWhatsNew // dont show if they have clicked Got it
                    ) {
                        var target = void 0;
                        var optionsWhatsNew = void 0;
                        if (this.props.IsPaneSingleColumn) {
                            target = document.getElementsByClassName("modulesFlyout-singleColumnContainer")[0];
                            optionsWhatsNew = { my: "top center", at: "top center", adjust_y: 100 };
                        }
                        else {
                            target = document.getElementsByClassName("modulesFlyout-container")[0];
                            optionsWhatsNew = { my: "left center", at: "right top", adjust_y: 100, adjust_x: -50 };
                        }
                        var notification = {
                            AdditionalData: JSON.stringify([""]),
                            AdditionalDataType: "WhatsNewFeatureContract",
                            Message: $dyn.label("NavigationPane_WhatsNew"),
                            RuleId: $dyn.whatsNew.keyIds.navigationKey,
                            TargetControl: target,
                            Title: $dyn.label("NavigationPane_WhatsNewToolTip"),
                        };
                        $dyn.whatsNew.processWhatsNewMessage(notification, optionsWhatsNew);
                    }
                };
                ModulesFlyout.prototype.render = function () {
                    if (!this.state.activeModule || !this.state.activeLinks || this.state.activeLinks.length === 0) {
                        return null;
                    }
                    var flyoutClasses = "modulesFlyout dashboardTiles_wide";
                    var flyoutContainerClasses = "modulesFlyout-container";
                    var backButton = (React.createElement("button", { className: "modulesFlyout-backButton ChevronLeft-symbol", type: "button", onClick: this.props.CloseFlyout, title: $dyn.label("NavigationPane_Back") }));
                    var closeButton = (React.createElement("button", { className: "modulesFlyout-closeButton Cancel-symbol", type: "button", onClick: this.props.BeforeNavigate, title: $dyn.label("NavBar_Close") }));
                    if (this.props.ExpandView) {
                        flyoutClasses += " modulesFlyout-isExpand";
                    }
                    if (this.state.loading) {
                        flyoutClasses += " modulesFlyout-isLoading";
                    }
                    if (this.props.IsPaneSingleColumn) {
                        flyoutContainerClasses = "modulesFlyout-singleColumnContainer";
                        flyoutClasses += " singleColumnFlyout";
                    }
                    var toolStrip = (React.createElement("div", { className: "modulesFlyout-toolStrip" },
                        React.createElement("button", { className: "modulesFlyout-ExpandAll", type: "button", onClick: this.menuExpandView, tabIndex: -1, title: $dyn.label("NavigationPane_ExpandAllToolTip") }, $dyn.label("NavigationPane_ExpandAllToolTip") + " "),
                        React.createElement("button", { className: "modulesFlyout-CollapseAll", type: "button", onClick: this.menuCollapseView, tabIndex: -1, title: $dyn.label("NavigationPane_CollapseAllToolTip") }, $dyn.label("NavigationPane_CollapseAllToolTip") + " ")));
                    return (React.createElement("div", { className: flyoutClasses, role: "group" },
                        this.props.IsPaneSingleColumn ? null : toolStrip,
                        React.createElement("div", { ref: "subc", className: flyoutContainerClasses, tabIndex: 0 },
                            this.props.IsPaneSingleColumn
                                ? React.createElement("div", { className: "modulesFlyout-header", tabIndex: 0 },
                                    backButton,
                                    React.createElement("span", { className: "modulesFlyout-activeModule" }, DynReact.ModuleStore.getActiveModuleLabel()),
                                    closeButton)
                                : null,
                            this.props.IsPaneSingleColumn ? toolStrip : null,
                            this.renderItems())));
                };
                ModulesFlyout.prototype.recalculateFlyoutWidth = function () {
                    // Chrome bug 247963 prevents flex from updating the width correctly if the number of columns changes.
                    if (!this.props.IsPaneSingleColumn) {
                        if (!this.state.activeLinks || this.state.activeLinks.length === 0 || !this.refs.subc) {
                            return;
                        }
                        var $flyoutContainer = $(this.refs.subc);
                        if (this.state.activeLinks && this.state.activeLinks.length > 0) {
                            $flyoutContainer.parent().css("width", "0px"); // Required for web-kit to not default to max-width of the parent when we have extra available space.
                            var scrollWidth = $flyoutContainer[0].scrollWidth + 20;
                            $flyoutContainer.parent().css("width", scrollWidth + "px");
                        }
                    }
                };
                ModulesFlyout.prototype.renderItems = function () {
                    var e_1, _a;
                    var items = [];
                    DynReact.ModuleStore._collapsedMenus = [];
                    try {
                        for (var _b = __values(this.state.activeLinks), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var item = _c.value;
                            if (!item.expanded) {
                                DynReact.ModuleStore._collapsedMenus.push(item.id);
                            }
                            this.renderItem(items, item, 0, false);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    this._lastLinkCount = this._currentLinkCount;
                    this._currentLinkCount = items.length;
                    this.props.ReportFlyoutItemCount(items.length - 1);
                    return items;
                };
                ModulesFlyout.prototype.renderItem = function (items, item, level, last) {
                    if (item.children) {
                        this.renderGroup(items, item, level, level === 0 || last);
                    }
                    else if (item.tile) {
                        items.push(React.createElement(UI.Tile, { BeforeNavigate: this.props.BeforeNavigate, Favorite: item.favorite, FeatureName: "sitemap", FormName: item.formName, Id: item.id, Image: item.image, ImageType: item.imageType, key: item.id, Label: item.label, MenuItemName: item.menuItem, MenuItemType: item.menuItemType, Selected: items.length === this.props.SelectedFlyoutItem }));
                    }
                    else {
                        items.push(React.createElement(UI.ModuleLink, { BeforeNavigate: this.props.BeforeNavigate, Favorite: item.favorite, FeatureName: "sitemap", FormName: item.formName, Id: item.id, key: item.id, Label: item.label, Last: last, Level: level, MenuItemName: item.menuItem, MenuItemType: item.menuItemType, Selected: items.length === this.props.SelectedFlyoutItem }));
                    }
                };
                ModulesFlyout.prototype.renderGroup = function (items, item, level, spaceAfterLast) {
                    items.push(React.createElement(UI.ModuleLinkGroup, { Expanded: item.expanded, Id: item.id, key: item.id, Label: item.label, Last: !item.expanded && spaceAfterLast, Level: level, Selected: items.length === this.props.SelectedFlyoutItem, SetSelectedFlyoutItem: this.props.SetSelectedFlyoutItem }));
                    if (item.expanded) {
                        for (var i = 0; i < item.children.length; i++) {
                            var child = item.children[i];
                            if (!item.expanded) {
                                DynReact.ModuleStore._collapsedMenus.push(item.id);
                            }
                            this.renderItem(items, child, level + 1, spaceAfterLast && i === item.children.length - 1);
                        }
                    }
                    else if (item.children.length > 0) {
                        DynReact.ModuleStore._collapsedMenus.push(item.id);
                    }
                };
                return ModulesFlyout;
            }(React.Component));
            UI.ModulesFlyout = ModulesFlyout;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModulesFlyout.js.map
